module.exports = __webpack_public_path__ + "static/media/6. G6.Superficie sólida. 34 x 50 x 23 cm. 2021 copy.531677ef.png";